import {
  ACTIVITYLOG_ALL,
  ACTIVITYLOG_LOADING,
  ACTIVITYLOG_ERROR,
  ACTIVITYLOG_RESET,
} from '../../actions/types';

const initialState = {
  rows: [],
  count: 0,
  page: 1,
  size: 50,
  isLoading: false,
  isCompleted: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ACTIVITYLOG_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case ACTIVITYLOG_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case ACTIVITYLOG_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    case ACTIVITYLOG_RESET:
      return initialState;
    default:
      return state;
  }
}
